module.exports = __webpack_public_path__ + "img/unhide.dd5609e0.svg";